import Logo from './themes/BGH';

export default Logo;
